export default __webpack_public_path__ + "static/media/secondd.49eb1c7a.png";